import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mergeQueue: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueue',
    description: 'Text for the merge queue',
    defaultMessage: 'Merge queue',
  },
  mergeQueuesTitle: {
    id: 'frontbucket.settings.mergeQueueConfig.page.title',
    description: 'Title for the merge queues page',
    defaultMessage: 'Merge queues',
  },
  inactiveStateHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.page.inactiveStateHeader',
    description: 'Title for the inactive state message',
    defaultMessage: 'Merge queue setup',
  },
  inactiveStateDescription: {
    id: 'frontbucket.settings.mergeQueueConfig.page.inactiveStateDescription',
    description: 'Description for the inactive state message',
    defaultMessage:
      'To finish setup, add and configure the merge queue pipeline and then activate the merge queue.',
  },
  howToSetupMergeQueue: {
    id: 'frontbucket.settings.mergeQueueConfig.page.howToSetupMergeQueue',
    description: 'Text for the how to setup merge queue',
    defaultMessage: 'How to setup a merge queue',
  },
  activate: {
    id: 'frontbucket.settings.mergeQueueConfig.page.activate',
    description: 'Text for the activate action',
    defaultMessage: 'Activate',
  },
  activateMergeQueue: {
    id: 'frontbucket.settings.mergeQueueConfig.page.activateMergeQueue',
    description: 'Text for the activate merge queue',
    defaultMessage: 'Activate merge queue',
  },
  pipelinesDisabledTitle: {
    id: 'frontbucket.settings.mergeQueueConfig.page.pipelinesDisabledTitle',
    description: 'Title for the pipelines disabled message',
    defaultMessage: 'Automate your path to production with merge queues',
  },
  pipelinesDisabledDescription: {
    id: 'frontbucket.settings.mergeQueueConfig.page.pipelinesDisabledDescription',
    description: 'Description for the pipelines disabled message',
    defaultMessage:
      'Enable Bitbucket Pipelines to start using merge queues and keep your main branch green. You’ll also get the power to automate your tests, speed up builds with caching, and deploy code to any environment with every push.',
  },
  enablePipelines: {
    id: 'frontbucket.settings.mergeQueueConfig.page.action.enablePipelines',
    description: 'Text for the `Enable Pipelines` action',
    defaultMessage: 'Enable Pipelines',
  },
  createMergeQueue: {
    id: 'frontbucket.settings.mergeQueueConfig.page.action.addMergeQueueConfig',
    description:
      'Text for the `Add a merge queue configuration` modal button trigger and modal header',
    defaultMessage: 'Create a merge queue',
  },
  introMsg: {
    id: 'frontbucket.settings.mergeQueueConfig.introMsg',
    description: 'Form intro message',
    defaultMessage:
      'Control how you merge your pull requests with merge queues. {learnMore}',
  },
  learnMore: {
    id: 'frontbucket.settings.mergeQueueConfig.learnMore',
    description: 'Learn more text',
    defaultMessage: 'Learn more about managing merge queues',
  },
  emptyStateHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.emptyStateHeader',
    description: 'Empty state header text',
    defaultMessage: 'Scale your team’s merge velocity with merge queues',
  },
  emptyStateDescription: {
    id: 'frontbucket.settings.mergeQueueConfig.emptyStateDescription',
    description: 'Empty state description text',
    defaultMessage:
      'Enable merge queues to automate pull request integration and eliminate merge conflicts across your repository. Provide your developers with a faster, more reliable path to the main branch by automating compatibility checks with Bitbucket Pipelines.',
  },
  contactAdmin: {
    id: 'frontbucket.settings.mergeQueueConfig.contactAdmin',
    description: 'Text for contacting an admin',
    defaultMessage:
      'Contact your repository administrator to create a merge queue.',
  },
  nameTableHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.tableHeader.name',
    description: 'Table header for merge queue Name column',
    defaultMessage: 'Name',
  },
  targetBranchTableHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.tableHeader.targetBranch',
    description: 'Table header for merge queue Target branch column',
    defaultMessage: 'Target branch',
  },
  strategyTableHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.tableHeader.strategy',
    description: 'Table header for merge queue Strategy column',
    defaultMessage: 'Strategy',
  },
  customSettingsTableHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.tableHeader.customSettings',
    description: 'Table header for merge queue Custom settings column',
    defaultMessage: 'Custom settings',
  },
  statusTableHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.tableHeader.status',
    description: 'Table header for merge queue Status column',
    defaultMessage: 'Status',
  },
  actionsTableHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.tableHeader.actions',
    description: 'Table header for merge queue Actions column',
    defaultMessage: 'Actions',
  },
  pullRequestTableHeader: {
    id: 'frontbucket.settings.mergeQueuePullRequests.tableHeader.pullRequest',
    description: 'Table header for merge queue Pull request column',
    defaultMessage: 'Pull request',
  },
  summaryTableHeader: {
    id: 'frontbucket.settings.mergeQueuePullRequests.tableHeader.summary',
    description: 'Table header for merge queue Summary column',
    defaultMessage: 'Summary',
  },
  pipelineTableHeader: {
    id: 'frontbucket.settings.mergeQueuePullRequests.tableHeader.pipeline',
    description: 'Table header for merge queue Pipeline column',
    defaultMessage: 'Pipeline',
  },
  createdTableHeader: {
    id: 'frontbucket.settings.mergeQueuePullRequests.tableHeader.created',
    description: 'Table header for merge queue Created column',
    defaultMessage: 'Created',
  },
  dateAddedTableHeader: {
    id: 'frontbucket.settings.mergeQueuePullRequests.tableHeader.dateAdded',
    description: 'Table header for merge queue Date added column',
    defaultMessage: 'Date added',
  },
  noPullRequestsQueued: {
    id: 'frontbucket.settings.mergeQueuePullRequests.noPullRequestsQueued',
    description: 'Text for no pull requests queued',
    defaultMessage: 'No pull requests have been added to this merge queue yet',
  },
  pullRequestByLine: {
    id: 'frontbucket.settings.mergeQueuePullRequests.pullRequestByLine',
    description:
      'Text describing the pull request: the author, ID, and how recently it was updated',
    defaultMessage: '{author} - #{id}, updated {date}',
  },
  pullRequestArOrdered: {
    id: 'frontbucket.settings.mergeQueuePullRequests.pullRequestArOrdered',
    description:
      'Text describing the pull request are ordered by the order in the merge queue',
    defaultMessage:
      'Pull requests are listed in the order they were added to the merge queue.',
  },
  draining: {
    id: 'frontbucket.settings.mergeQueueConfig.status.draining',
    description: 'Text for draining status of a merge queue',
    defaultMessage: 'Draining',
  },
  active: {
    id: 'frontbucket.settings.mergeQueueConfig.status.active',
    description: 'Text for active status of a merge queue',
    defaultMessage: 'Active',
  },
  inactive: {
    id: 'frontbucket.settings.mergeQueueConfig.status.inactive',
    description: 'Text for inactive status of a merge queue',
    defaultMessage: 'Inactive',
  },
  mergeQueueActivateModalHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueActivateModal.header',
    description: 'Header for the merge queue activate modal',
    defaultMessage: 'Activate merge queue',
  },
  mergeQueueActivateModalBody: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueActivateModal.body',
    description: 'Body for the merge queue activate modal',
    defaultMessage:
      'To finish setting up your queue, you must update your bitbucket-pipelines.yml file. This ensures your pipelines are configured to run the automated checks required for merging.',
  },
  buildConcurrency: {
    id: 'frontbucket.settings.mergeQueueConfig.customSettings.buildConcurrency',
    description: 'Text for build concurrency',
    defaultMessage: 'Build concurrency',
  },
  mergeBatchSize: {
    id: 'frontbucket.settings.mergeQueueConfig.customSettings.mergeBatchSize',
    description: 'Text for merge batch size',
    defaultMessage: 'Merge batch size',
  },
  maximumBatchWaitTime: {
    id: 'frontbucket.settings.mergeQueueConfig.customSettings.maximumBatchWaitTime',
    description: 'Text for maximum batch wait time',
    defaultMessage: 'Maximum batch wait time',
  },
  editAction: {
    id: 'frontbucket.settings.mergeQueueConfig.action.edit',
    description: 'Text for edit action',
    defaultMessage: 'Edit',
  },
  drainAction: {
    id: 'frontbucket.settings.mergeQueueConfig.action.drain',
    description: 'Text for drain action',
    defaultMessage: 'Drain',
  },
  drainActionDisabledTooltip: {
    id: 'frontbucket.settings.mergeQueueConfig.action.drainActionDisabledTooltip',
    description: 'Text for drain action disabled tooltip',
    defaultMessage: 'Drain is not available for draining merge queues',
  },
  deleteAction: {
    id: 'frontbucket.settings.mergeQueueConfig.action.delete',
    description: 'Text for delete action',
    defaultMessage: 'Delete',
  },
  deleteActionDisabledTooltip: {
    id: 'frontbucket.settings.mergeQueueConfig.action.deleteActionDisabledTooltip',
    description: 'Text for delete action disabled tooltip',
    defaultMessage:
      'Delete is not available for active merge queues or merge queues with pull requests',
  },
  activateAction: {
    id: 'frontbucket.settings.mergeQueueConfig.action.activate',
    description: 'Text for activate action',
    defaultMessage: 'Activate',
  },
  activateActionDisabledTooltip: {
    id: 'frontbucket.settings.mergeQueueConfig.action.activateActionDisabledTooltip',
    description: 'Text for activate action disabled tooltip',
    defaultMessage: 'Activate is not available for active merge queues',
  },
  deactivateAction: {
    id: 'frontbucket.settings.mergeQueueConfig.action.deactivate',
    description: 'Text for deactivate action',
    defaultMessage: 'Deactivate',
  },
  deactivateActionDisabledTooltip: {
    id: 'frontbucket.settings.mergeQueueConfig.action.deactivateActionDisabledTooltip',
    description: 'Text for deactivate action disabled tooltip',
    defaultMessage: 'Deactivate is not available for inactive merge queues',
  },
  viewPullRequestsAction: {
    id: 'frontbucket.settings.mergeQueueConfig.action.viewPullRequests',
    description: 'Text for view pull requests action',
    defaultMessage: 'View pull requests',
  },
  clearAction: {
    id: 'frontbucket.settings.mergeQueueConfig.action.clear',
    description: 'Text for clear action',
    defaultMessage: 'Clear',
  },
  clearActionDisabledTooltip: {
    id: 'frontbucket.settings.mergeQueueConfig.action.clearActionDisabledTooltip',
    description: 'Text for clear action disabled tooltip',
    defaultMessage: 'Clear is not available for active merge queues',
  },
  modalHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.header',
    description: 'Header for the add merge queue modal',
    defaultMessage: 'Create merge queue',
  },
  modalEditHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.editHeader',
    description: 'Header for the edit merge queue modal',
    defaultMessage: 'Edit merge queue',
  },
  cancel: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.cancel',
    description: 'Text for closing merge queue modal',
    defaultMessage: 'Cancel',
  },
  create: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.create',
    description: 'Text for creating merge queue',
    defaultMessage: 'Create',
  },
  save: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.save',
    description: 'Text for saving merge queue',
    defaultMessage: 'Save',
  },
  selectBranchPlaceholder: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.selectBranchPlaceholder',
    description: 'Text for selecting a branch in the merge queue modal',
    defaultMessage: 'Select a branch',
  },
  mergeQueueNameLabel: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.mergeQueueName.label',
    description: 'Label for merge queue name input',
    defaultMessage: 'Name',
  },
  mergeQueueNamePlaceholder: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.mergeQueueName.placeholder',
    description: 'Placeholder for merge queue name input',
    defaultMessage: 'Enter a name for the merge queue',
  },
  queueStrategyLabel: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.queueStrategy.label',
    description: 'Label for queue strategy select field',
    defaultMessage: 'Queue strategy',
  },
  queueStrategyPlaceholder: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.queueStrategy.placeholder',
    description: 'Placeholder for queue strategy select field',
    defaultMessage: 'Select a queue strategy',
  },
  mergeStrategy: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.mergeStrategy.label',
    description: 'Label for merge strategy select field',
    defaultMessage: 'Merge strategy',
  },
  mergeStrategyPlaceholder: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.mergeStrategy.placeholder',
    description: 'Placeholder for merge strategy select field',
    defaultMessage: 'Select a merge strategy',
  },
  pullRequestsOrderingCriteria: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.pullRequestsOrderingCriteria.label',
    description: 'Label for pull requests ordering criteria select field',
    defaultMessage: 'Pull requests ordering criteria',
  },
  pullRequestsOrderingCriteriaPlaceholder: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.pullRequestsOrderingCriteria.placeholder',
    description: 'Placeholder for pull requests ordering criteria select field',
    defaultMessage: 'Select a pull requests ordering criteria',
  },
  pullRequestsOrderingCriteriaTimeBased: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.pullRequestsOrderingCriteria.timeBased',
    description: 'Label for time based pull requests ordering criteria',
    defaultMessage: 'Time based',
  },
  pullRequestsOrderingCriteriaBranchPatternAndTimeBased: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.pullRequestsOrderingCriteria.branchPatternAndTimeBased',
    description:
      'Label for branch pattern and time based pull requests ordering criteria',
    defaultMessage: 'Branch pattern and time based',
  },
  sourceBranchPatternsLabel: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.sourceBranchPatterns.label',
    description: 'Label for source branch patterns input field',
    defaultMessage: 'Prioritized source branch patterns',
  },
  sourceBranchPatternsPlaceholder: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.sourceBranchPatterns.placeholder',
    description: 'Placeholder for source branch patterns input field',
    defaultMessage: 'Comma separated ant-style patterns',
  },
  sourceBranchPatternsRequired: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.sourceBranchPatterns.required',
    description: 'Error message for source branch patterns input field',
    defaultMessage: 'At least one source branch pattern is required',
  },
  sourceBranchPatternsInvalidAntPattern: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.sourceBranchPatterns.invalidAntPattern',
    description:
      'Error message when source branch patterns contain invalid Ant-style patterns',
    defaultMessage:
      'Only comma separated ant-style patterns are accepted (e.g., feature/*, **/hotfix-*, release-?)',
  },
  sourceBranchPatternsTooGeneric: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.sourceBranchPatterns.tooGeneric',
    description:
      'Error message when source branch patterns contain only wildcards like * or **',
    defaultMessage:
      'Wildcard only patterns are not allowed. Please restrict to a more specific ant-style branch pattern such as hotfix/*.',
  },
  queueStrategyStrictPerPR: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.queueStrategy.strictPerPR',
    description: 'Label for strict per PR queue strategy',
    defaultMessage: 'Strict per pull request',
  },
  queueStrategyOptimisticBatchedPR: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.queueStrategy.optimisticBatchedPR',
    description: 'Label for optimistic batched PR queue strategy',
    defaultMessage: 'Optimistic batched pull request',
  },
  queueStrategyStrictBatchedPR: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.queueStrategy.strictBatchedPR',
    description: 'Label for strict batched PR queue strategy',
    defaultMessage: 'Strict batched pull request',
  },
  queueStrategyOptimisticPerPR: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.queueStrategy.optimisticPerPR',
    description: 'Label for optimistic per PR queue strategy',
    defaultMessage: 'Optimistic per pull request',
  },
  mergeQueueSettingsHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.mergeQueueSettingsHeader',
    description: 'Header for merge queue settings section',
    defaultMessage: 'Merge queue settings',
  },
  mergeQueueSettingsDescription: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.mergeQueueSettingsDescription',
    description: 'Description for merge queue settings section',
    defaultMessage:
      'Configure the settings for the merge queue to optimize your workflow.',
  },
  waitTimeUnitSeconds: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.waitTime.unit.second',
    description: 'Label for wait time unit in seconds',
    defaultMessage: 'seconds',
  },
  waitTimeUnitMinutes: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.waitTime.unit.minute',
    description: 'Label for wait time unit in minutes',
    defaultMessage: 'minutes',
  },
  waitTimeUnitHours: {
    id: 'frontbucket.settings.mergeQueueConfig.modal.waitTime.unit.hour',
    description: 'Label for wait time unit in hours',
    defaultMessage: 'hours',
  },
  createSuccess: {
    id: 'frontbucket.settings.mergeQueueConfig.createSuccess',
    description: 'Success message after creating a merge queue',
    defaultMessage:
      'Your merge queue has been added. To finish setup, add the merge queue pipeline configuration file and activate the merge queue.',
  },
  createError: {
    id: 'frontbucket.settings.mergeQueueConfig.createError',
    description: 'Error message after creating a merge queue',
    defaultMessage: 'Failed to create merge queue.',
  },
  editSuccess: {
    id: 'frontbucket.settings.mergeQueueConfig.editSuccess',
    description: 'Success message after editing a merge queue',
    defaultMessage: 'Merge queue successfully updated.',
  },
  editError: {
    id: 'frontbucket.settings.mergeQueueConfig.editError',
    description: 'Error message after editing a merge queue',
    defaultMessage: 'Failed to update merge queue.',
  },
  mergeQueueConfigurations: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueConfigurations',
    description: 'Text for merge queue configurations',
    defaultMessage: 'merge queue configurations',
  },
  mergeQueueNameAlreadyExists: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueNameAlreadyExists',
    description: 'Error message when merge queue name already exists',
    defaultMessage: 'A merge queue with this name already exists',
  },
  mergeQueueNameMustStartWithAlphabet: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueNameMustStartWithAlphabet',
    description:
      'Error message when merge queue name does not start with an alphabet',
    defaultMessage: 'Merge queue name must start with a letter.',
  },
  mergeQueueNameInvalidCharacters: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueNameInvalidCharacters',
    description:
      'Error message when merge queue name contains invalid characters',
    defaultMessage:
      'Merge queue name can only contain letters, numbers, hyphens, and underscores.',
  },
  mergeQueueDeleteModalHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDeleteModal.header',
    description: 'Header for the merge queue delete modal',
    defaultMessage: 'Delete merge queue',
  },
  mergeQueueDeleteModalBody: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDeleteModal.body',
    description: 'Body for the merge queue delete modal',
    defaultMessage: 'Are you sure you want to delete this merge queue?',
  },
  mergeQueueDeleteWarningTitle: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDeleteModal.warningTitle',
    description: 'Warning title for the merge queue delete modal',
    defaultMessage: 'Unable to delete merge queue',
  },
  mergeQueueDeleteWarningForNonEmptyQueue: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDeleteModal.warningForNonEmptyQueue',
    description:
      'Warning message for the merge queue delete modal for non empty queue',
    defaultMessage:
      'This merge queue is not empty. Please wait for all pull requests to be processed or clear them before attempting to delete.',
  },
  mergeQueueDeleteWarningForActiveQueue: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDeleteModal.warningForActiveQueue',
    description:
      'Warning message for the merge queue delete modal for active queue',
    defaultMessage:
      'This merge queue is currently active. Please drain it before attempting to delete.',
  },
  mergeQueueDeleteSuccess: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDeleteSuccess',
    description: 'Success message after deleting a merge queue',
    defaultMessage: 'Merge queue successfully deleted.',
  },
  mergeQueueDeleteError: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDeleteError',
    description: 'Error message after deleting a merge queue',
    defaultMessage: 'Failed to delete merge queue.',
  },
  allowText: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDrainingModal.allowText',
    description: 'Text for allowing users to add pull requests to the queue',
    defaultMessage: 'allow',
  },
  stopText: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueDrainingModal.stopText',
    description:
      'Text for stopping users from adding pull requests to the queue',
    defaultMessage: 'stop',
  },
  mergeQueueClearModalHeader: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueClearModal.header',
    description: 'Header for the merge queue clear modal',
    defaultMessage: 'Clear merge queue',
  },
  mergeQueueClearModalBody: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueClearModal.body',
    description: 'Body for the merge queue clear modal',
    defaultMessage:
      'This will remove all pull requests from the queue. Pull requests that were removed from the queue will not merge until they are queued to merge again. This won’t alter your code or stop any in-progress builds.',
  },
  mergeQueueClearWarningForActiveQueue: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueClearModal.warningForActiveQueue',
    description:
      'Warning message for the merge queue clear modal for active queue',
    defaultMessage:
      'This merge queue is currently active. Please drain it before attempting to clear.',
  },
  mergeQueueClearSuccess: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueClearSuccess',
    description: 'Success message after clearing a merge queue',
    defaultMessage:
      'Request to clear the merge queue has been sent successfully.',
  },
  mergeQueueClearError: {
    id: 'frontbucket.settings.mergeQueueConfig.mergeQueueClearError',
    description: 'Error message after clearing a merge queue',
    defaultMessage: 'Failed to clear merge queue.',
  },
  removeFromQueueAction: {
    id: 'frontbucket.settings.mergeQueuePullRequest.action.removeFromQueue',
    description: 'Text for remove from queue action',
    defaultMessage: 'Remove from queue',
  },
  moveToTopAction: {
    id: 'frontbucket.settings.mergeQueuePullRequest.action.moveToTop',
    description: 'Text for move to top action',
    defaultMessage: 'Move to top',
  },
  dequeuePullRequestModalHeader: {
    id: 'frontbucket.settings.mergeQueuePullRequest.dequeuePullRequestModal.header',
    description: 'Header for the dequeue pull request modal',
    defaultMessage: 'Remove pull request #{pullRequestNumber} from queue',
  },
  dequeuePullRequestModalBody: {
    id: 'frontbucket.settings.mergeQueuePullRequest.dequeuePullRequestModal.body',
    description: 'Body for the dequeue pull request modal',
    defaultMessage:
      'Removing this pull request from the queue means it will not be merged and may impact other pull requests that depend on these changes. You can add it back later, but it will lose its current spot in the queue.',
  },
  pullRequestDequeuedSuccess: {
    id: 'frontbucket.settings.mergeQueuePullRequest.pullRequestDequeuedSuccess',
    description: 'Success message after dequeuing a pull request',
    defaultMessage:
      'Request to remove the pull request from the merge queue has been sent successfully.',
  },
  pullRequestDequeuedError: {
    id: 'frontbucket.settings.mergeQueuePullRequest.pullRequestDequeuedError',
    description: 'Error message after dequeuing a pull request',
    defaultMessage: 'Failed to remove pull request from the merge queue.',
  },
  moveToTopPullRequestModalHeader: {
    id: 'frontbucket.settings.mergeQueuePullRequest.moveToTopPullRequestModal.header',
    description: 'Header for the move to top pull request modal',
    defaultMessage: 'Move pull request #{pullRequestNumber} to top',
  },
  moveToTopPullRequestModalBody: {
    id: 'frontbucket.settings.mergeQueuePullRequest.moveToTopPullRequestModal.body',
    description: 'Body for the move to top pull request modal',
    defaultMessage:
      'Moving this to the top of the merge queue may impact other pull requests that depend on these changes.',
  },
  moveToTopPullRequestSuccess: {
    id: 'frontbucket.settings.mergeQueuePullRequest.moveToTopPullRequestSuccess',
    description: 'Success message after moving a pull request to top',
    defaultMessage:
      'Request to move the pull request to top has been sent successfully.',
  },
  moveToTopPullRequestError: {
    id: 'frontbucket.settings.mergeQueuePullRequest.moveToTopPullRequestError',
    description: 'Error message after moving a pull request to top',
    defaultMessage: 'Failed to move pull request to top.',
  },
  paidPlanRequiredHeader: {
    id: 'frontbucket.mergeQueues.landingPage.paidPlanRequiredHeader',
    description:
      'Header for the Merge queues landing page empty state when paid plan is required',
    defaultMessage:
      'Get a Standard or Premium monthly plan to unlock this functionality',
  },
  paidPlanRequiredDescription: {
    id: 'frontbucket.mergeQueues.landingPage.paidPlanRequiredDescription',
    description:
      'Description for the Merge queues landing page empty state when paid plan is required',
    defaultMessage:
      'Start a free trial of a Standard or Premium plan to automate your pull request merges and keep your main branch green without slowing down your team’s delivery.',
  },
  explorePlans: {
    id: 'frontbucket.mergeQueues.landingPage.explorePlans',
    description: 'Label for the explore plans action button',
    defaultMessage: 'Explore plans',
  },
});
